import YTPlayer from '../../scripts/components/YTPlayer';

window.onReady(() => {
  YTPlayer.init();
});
